<nb-card
  style="margin-bottom: 0; max-width: 500px; width: 400px"
  *ngIf="processRequest == 'request'"
>
  <nb-card-header>
    <div class="d-flex justify-content-between">
      Notification
      <button
        (click)="dismiss()"
        type="button"
        class="btn-close"
        aria-label="Close"
      ></button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <ng-container>
      <div [innerHTML]="question"></div>
    </ng-container>
  </nb-card-body>
  <nb-card-footer>
    <nb-checkbox
      nbTooltip="This option allow you to automatically log in as the flow's owner account 
      and will be cleared upon logging out."
      nbTooltipPlacement="bottom"
      (checkedChange)="toggleAutoLogin($event)"
      >Auto login</nb-checkbox
    >
    <div class="float-end">
      <ng-container *ngIf="processRequest === 'request'">
        <button
          (click)="handleChangeUser()"
          type="button"
          size="small"
          class="me-2"
          status="info"
          nbButton
        >
          Ok
        </button>
        <button (click)="dismiss()" size="small" status="basic" nbButton>
          Go Back
        </button>
      </ng-container>
    </div>
  </nb-card-footer>
</nb-card>
